<template>
  <div class="app-package">
    <div class="accordion-header">
      <slot name="txtAccordionHeader"></slot>
      <div class="accordion-button-wrapper">
        <b-btn class="accordion-toggle" @click="visible = !visible">
          <slot name="btnToggleClosed" v-if="!visible">mehr infos</slot>
          <slot name="btnToggleOpen" v-if="visible">minimieren</slot>
        </b-btn>
      </div>
    </div>
    <div class="accordion-content">
      <b-collapse :accordion="expandMultiple ? '' : 'bookable-accordion'" v-model="visible">
        <b-card>
          <div class="content" v-if="!isItemsNull">
            <BookableTariffOptionsRow
              @select="onSelect"
              :tariff-options="tariffOptionsForDisplay"
              :fields="tariffOptionFields"
              :selected="selected">
            </BookableTariffOptionsRow>
          </div>
          <div class="no-content" v-else>
            <slot name="txtAccordionNoContent"></slot>
          </div>
        </b-card>
      </b-collapse>
    </div>
  </div>
</template>

<script>

import BookableTariffOptionsRow from './BookableTariffOptionsRow.vue'

export default {
  name: 'BookableAccordion',
  components: { BookableTariffOptionsRow },
  created () {
    this.visible = this.open === (this.packets.items !== null && this.packets.items.length !== 0 ? this.packets.items[0].key : false)
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    onSelect (value) {
      this.$emit('select', value)
    }
  },
  computed: {
    isItemsNull: function () {
      return this.packets.items === null || this.packets.items.length === 0
    },
    tariffOptionsForDisplay: function () {
      return this.packets.items
    },
    tariffOptionFields: function () {
      return this.fields
    }
  },
  props: {
    packets: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    open: {
      type: String,
      required: false
    },
    selected: {
      type: String,
      required: false
    },
    expandMultiple: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}

</script>
